module.exports = __webpack_public_path__ + "img/ico26.a82a8d28.jpg";